import React from 'react';
import { ReactComponent as ASvg } from '../../../../resources/images/regulatorStateA.svg';
import { ReactComponent as OnSvg } from '../../../../resources/images/onWithoutColor.svg';
import { ReactComponent as OffSvg } from '../../../../resources/images/offWithoutColor.svg';
import Icon from '@ant-design/icons';
import { Tooltip } from 'antd';

export const RegulatorStateButton = ({ handleClick, ecIsOn, trueCrashes, ecIsOnTitle }) => {
    const [isAlarm, setIsAlarm] = React.useState(false)

    React.useEffect(() => {
        setIsAlarm(defAlarm())
    }, [trueCrashes])

    const defAlarm = () => trueCrashes && trueCrashes.length > 0;

    return <div
        style={{
            color: isAlarm ? '#FF0000' : ecIsOn ? '#00FA9E' : '#666',
            fontSize: '40px',
        }}
        onClick={handleClick}
        className='widget-button'
    >
        <Tooltip
            placement="topLeft"
            title={ecIsOnTitle?.title}
        >
            {
                isAlarm
                    ? <Icon component={ASvg} />
                    : ecIsOn == true
                        ? <Icon component={OnSvg} />
                        : ecIsOn == false
                            ? <Icon component={OffSvg} />
                            : null
            }
        </Tooltip>
    </div>
}